import axios from 'axios';

export const dataLayer = window.dataLayer || [];

const LOCAL_DOMAINS = ["localhost", "127.0.0.1", "www.dehn-international.com.ddev.site","www.dehn.de.ddev.site"];
let domain = "https://www.dehn.de";

if (window.location.hostname.includes("q.")) {
  domain = "https://test.dehn.de";
} else {
  domain = "https://" + window.location.hostname;
}

if (LOCAL_DOMAINS.includes(window.location.hostname)) {
  domain = "https://test.dehn.de";
}

export const DCFORMSERVICE = axios.create({
  baseURL: domain + '/store/api/v1.2/dehnconcept/'
})
